const QUERY = `mutation MarkAllNotificationsRead {
  markAllNotificationsRead { 
    success
  }
}`;

export const markAllNotificationsRead = {
  query: QUERY,
};
